// src/audio/effects.js
// Reusable effect factories. Currently: convolution reverb + simple EQ.

import * as Tone from 'tone';

/**
 * Build a convolution reverb. We synthesize an impulse response so we
 * don't need to ship a binary IR file. For a more natural sound, this
 * can later be swapped for a recorded IR.
 */
export async function createReverb({
  decay = 3.5,
  preDelay = 0.02,
  wet = 1.0
} = {}) {
  const reverb = new Tone.Reverb({
    decay,
    preDelay,
    wet
  });
  // generate() returns a Promise — must await for the IR buffer
  await reverb.generate();
  return reverb;
}

/**
 * Simple 3-band EQ (low shelf, mid peak, high shelf) for a track or master.
 */
export function createEQ({
  low = 0,
  mid = 0,
  high = 0
} = {}) {
  return new Tone.EQ3({
    low,
    mid,
    high,
    lowFrequency: 250,
    highFrequency: 4000
  });
}
